import React, { useState } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import Button from '../button';
import { Grid, Paragraph } from '../UIKit/system';
import { getThemeColor } from '../../utils/styles';
import parseStoryblokLink from '../../utils/parse-storyblok-link';
import RichTextField from '../rich-text-field';

interface HubspotMeetingProps {
  text?: Record<string, any>;
  meetings: {
    _uid: string;
    title: string;
    link: {
      url: string;
    };
  }[];
}

export function HubspotMeeting(props: HubspotMeetingProps) {
  const { meetings, text } = props;
  const [calendarId, setCalendarId] = useState('');

  const onChangeCalendar = (id: string) => {
    return (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      setCalendarId(id);
    };
  };

  return (
    <>
      {text && (
        <Paragraph pb={40} textAlign="center">
          <RichTextField data={text} />
        </Paragraph>
      )}

      <ButtonsGrid>
        {meetings.map((meeting) => (
          <Button
            key={meeting._uid}
            to="#"
            onClick={onChangeCalendar(meeting._uid)}
            inDarkBlock={calendarId === meeting._uid}
            transparent={calendarId !== meeting._uid}
          >
            {meeting.title}
          </Button>
        ))}
      </ButtonsGrid>

      {meetings.map((meeting) => (
        <MeetingSection key={meeting._uid} active={calendarId === meeting._uid}>
          <MeetingContainer
            key={meeting._uid}
            className="meetings-iframe-container"
            style={{ borderRadius: '16px' }}
            data-src={parseStoryblokLink(meeting.link)}
          />
        </MeetingSection>
      ))}

      <Helmet>
        <script
          type="text/javascript"
          src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
          async
        />
      </Helmet>
    </>
  );
}

const ButtonsGrid = styled(Grid).attrs(() => ({
  gridAutoFlow: 'row',
  gridTemplateColumns: [null, 'repeat(2, 1fr)'],
  gridGap: 15,
  justifyContent: 'center',
  margin: '0 auto 30px',
  width: [null, '80%']
}))``;

const MeetingSection = styled.div<{ active: boolean }>`
  height: ${(props) => (props.active ? 'auto' : '0')};
  overflow: hidden;
`;

const MeetingContainer = styled.div`
  background-color: ${getThemeColor('lightGrey')};
`;
